import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useOfferApi } from '../../src/offers/api';
import { offerKeys } from '../query-key-factory';
import { activationKeys } from './keys';

const useCreateMerchantActivation = () => {
  const OfferApi = useOfferApi();
  const queryClient = useQueryClient();

  const activateMerchant = async (merchantId: string) => {
    const { data } = await OfferApi.post(`/merchant/activations`, {
      merchant_id: merchantId,
    });
    return data;
  };

  return useMutation({
    mutationFn: activateMerchant,
    onSuccess: (_, merchantId) => {
      void queryClient.invalidateQueries({ queryKey: activationKeys().id(merchantId).detail });
    },
  });
};

const useClaimAllMerchantActivations = () => {
  const OfferApi = useOfferApi();
  const queryClient = useQueryClient();

  const claimAll = async (merchantIds: string[]) => {
    const { data } = await OfferApi.post(`/merchant/activations`, {
      merchant_id: merchantIds,
    });
    return data;
  };

  return useMutation({
    mutationFn: claimAll,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: offerKeys.all });
    },
  });
};
export { useClaimAllMerchantActivations, useCreateMerchantActivation };
